export default "__VITE_ASSET__ClhA1FgP__"